<template>
  <div class="mobile-nav-component">
    <a href="/">
      <img src="images/logo-mobile.svg" alt="LATAM Pass" />
    </a>
    <div class="dropdown ml-auto">
      <a
        id="logoutUser"
        href="#"
        class="dropdown-toggle mr-3"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img src="images/icon-user-mobile.svg" alt="Perfil" />
      </a>
      <div
        class="dropdown-menu dropdown-menu-right"
        aria-labelledby="logoutUser"
      >
        <a :href="urlogout" class="dropdown-item">Cerrar sesión</a>
      </div>
    </div>
    <a href="#" class @click="toggleNav = !toggleNav">
      <img src="images/icon-menu.svg" alt="ícono de menú" />
    </a>
    <div
      v-if="toggleNav"
      class="menu-background"
      :class="{ open: toggleNav }"
      @click="toggleNav = !toggleNav"
    ></div>
    <div class="mobile-menu" :class="{ open: toggleNav }" @click="clickNavMenu">
      <ul class="menu-list">
        <li>
          <a
            href="https://www.latam.com/es_cl/conocenos/mapa-de-nuestros-destinos/america/"
            target="_blank"
            class="destinations"
          >
            <img
              src="images/icon-destinos.svg"
              alt="ícono destinos"
              class="mr-2"
            />
            Descubre nuestros destinos
          </a>
        </li>
        <li>
          <a href="https://www.latam.com/corporate/es_cl/" target="_blank"
            >Corporate</a
          >
        </li>
        <li>
          <a href="https://helpdesk.latam.com/hc/" target="_blank"
            >Centro de Ayuda</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileNav",
  props: ["urlogout"],
  data() {
    return {
      toggleNav: false
    };
  },
  methods: {
    clickNavMenu(e) {
      e.stopPropagation();
    }
  }
};
</script>

<style scoped>
</style>
